import _ from 'lodash';

export const ALL_ITEMS_IN_STOCK ='ALL_ITEMS_IN_STOCK';
export const ALL_ITEMS_OUT_OF_STOCK ='ALL_ITEMS_OUT_OF_STOCK';
export const SOME_ITEMS_IN_STOCK ='SOME_ITEMS_IN_STOCK';
export const IN_STOCK_BEFORE_CUTOFF = 'IN_STOCK_BEFORE_CUTOFF';
export const IN_STOCK_AFTER_CUTOFF = 'IN_STOCK_AFTER_CUTOFF';
export const OOS = 'OOS';

export const AVAILABLE_FOR_PICK_UP_TODAY ='AVAILABLE_FOR_PICK_UP_TODAY';
export const NOT_AVAILABLE_FOR_PICK_UP_TODAY ='NOT_AVAILABLE_FOR_PICK_UP_TODAY';
export const AVAILABLE_IN_2_3_DAYS ='AVAILABLE_IN_2_3_DAYS';
export const CUSTOMER_DATA_CLOUD_COULD_NOT_BE_AUTHENTICATED = 'Customer Data Cloud account could not be authenticated. Please try again.';

export const STOCK_CLASS = {
    [ALL_ITEMS_IN_STOCK]: 'all-item',
    [SOME_ITEMS_IN_STOCK]: 'some-item',
    [ALL_ITEMS_OUT_OF_STOCK]: 'none-item',
    [IN_STOCK_BEFORE_CUTOFF]: 'in-stock-before',
    [IN_STOCK_AFTER_CUTOFF]: 'in-stock-after',
    [OOS]: 'oos',
};

export const PICKUP_CLASS = {
    [AVAILABLE_FOR_PICK_UP_TODAY]: 'all-item',
    [AVAILABLE_IN_2_3_DAYS]: 'some-item',
    [NOT_AVAILABLE_FOR_PICK_UP_TODAY]: 'none-item',
    [IN_STOCK_BEFORE_CUTOFF]: 'in-stock-before',
    [IN_STOCK_AFTER_CUTOFF]: 'in-stock-after',
    [OOS]: 'oos',
};

export const EVENT_SETSTORE_SUCCESS = 'regionStorePopup.setStoreSuccess';

/**
 * Consult the full list of SAP Customer Data Cloud response codes and error codes.
 * Refer: https://help.sap.com/docs/SAP_CUSTOMER_DATA_CLOUD/8b8d6fffe113457094a17701f63e3d6a/416d41b170b21014bbc5a10ce4041860.html
 */
export const CDC_ERROR_CODE = {
    SUCCESS: 0, // Success.
    UNAUTHORIZED_USER: 403005, // The user ID that is passed is not valid for this site.
    ACCOUNT_TEMPORARILY_LOCKED_OUT: 403120,
    UNIQUE_IDENTIFIER_EXISTS: 400003,
    LOGIN_IDENTIFIER_EXISTS: 403043,
    LOGIN_FAILED_CAPTCHA_REQUIRED: 401020,
};

export const CDC_ERROR_MESSAGE = {
    [CDC_ERROR_CODE.ACCOUNT_TEMPORARILY_LOCKED_OUT]: `Account Locked Out. If you don't remember your password, click on Forgot password and reset it now.`,
    [CDC_ERROR_CODE.UNIQUE_IDENTIFIER_EXISTS]: _.get(window, 'gigya.thisScript.globalConf.customLang.email_already_exists', `Oops! This email address is already registered to an account.<br>Please login or reset your password to continue`),
    [CDC_ERROR_CODE.LOGIN_IDENTIFIER_EXISTS]: _.get(window, 'gigya.thisScript.globalConf.customLang.login_identifier_exists', `Oops! This email address is already registered to an account.`),
    // TODO: Update from CDC
    NOT_AVAILABLE_LOGIN: _.get(window, 'gigya.thisScript.globalConf.customLang.email_not_already', `Hey, we would like to know more about you and complete your account registration, click below`),
	UPDATE_EMAIL_EXISTS: _.get(window, 'gigya.thisScript.globalConf.customLang.update_email_exists', `This account already exists.`),
};

export const CDC_ENABLE_DATA_PUSH = 'bris.cdc.enableDataPush';

export const CDC_LOCAL_STORE_DEFAULT = {
	regsiter: {
		name: 'Select your local store *',
		storeId: ' ',
	},
	update: {
		name: 'Select Store',
		storeId: ' ',
	},
};
export const EVENT_RELATED_UPDATE = 'variant.update';
export const EVENT_PRODUCT_QUICKVEW_SHOW = 'quickview.show';
export const CDC_LOCAL_STORE = {
    briscoes: 'data.localStoreBriscoes',
    rebel: 'data.localStoreRebel',
};

export const CDC_ACCOUNT_DATA = {
    ACQUISITION_CHANNEL: 'Online',
    ACQUISITION_CHANNEL_CHECKOUT: 'Checkout',
    ACQUISITION_CHANNEL_FOOTER: 'Online Footer',
    ACQUISITION_CHANNEL_MY_ACCOUNT: 'My Account',
    CUSTOMER_TYPE_CODE: 'ZW',
    SOURCE_OF_LAST_UPDATE: 'WEB',
};
export const UPDATE_DELIVERY_FAIL = 'Can not update delivery method.';
export const LOCAL_STORE_POSTCODE = 'postcode';
export const STAFF_CARD_NO = 'staffCardNo';
export const STAFF_CARD_NO_OPT = 'StaffCardNo';

export const DISCLAIMER_TEXT = 'Clearance Price Minus The Extra';



// WEBPACK FOOTER //
// ./constants.js